<template>
  <!-- 图片在左边的布局， thumbnailStyle为3时是3图，其余情况都是单图 -->
  <van-cell class="single-pic" v-if="article.thumbnailStyle !== 3" :url="this.getUrl()">
    <van-image
      class="right-cover"
      slot="title"
      fit="cover"
      radius="5px"
      :src="article.thumbnails[0].thumbnailUrl"
    >
      <img
        v-if="article.contentType === 9"
        class="bjh-play-icon"
        src="../../../assets/bjh_video_play_icon.png"
        alt="play_icon"
      />
    </van-image>
    <div slot="default" class="single-pic-default">
      <div class="single-pic-article-title">
        <span class="article-title van-multi-ellipsis--l3">{{
          article.title
        }}</span>
      </div>
      <span
        v-if="article.thumbnailStyle !== 3"
        class="label-wrap single-pic-label-wrap"
        >{{ article.publishTime | relativeTime }}</span
      >
    </div>
  </van-cell>

  <!-- 三图的布局方式 thumbnailStyle === 3-->
  <van-cell class="three-pic-class" v-else :url="this.getUrl()">
    <div slot="title" class="article-title van-multi-ellipsis--l3">{{ article.title }} </div>
    <div slot="label">
      <div class="cover-wrap">
        <div
          class="cover-wrap-item"
          v-for="(imgItem, index) in therePicturesPerCellImages"
          :key="index"
        >
          <van-image
            radius="5px"
            class="cover-image"
            fit="cover"
            :src="imgItem.thumbnailUrl"
          />
        </div>
      </div>
      <div class="label-wrap">
        <span>{{ article.publishTime | relativeTime }}</span>
      </div>
    </div>
  </van-cell>
</template>

<script>
export default {
  name: 'ResultItemIndex',
  components: {},
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    therePicturesPerCellImages () {
      // filter 方法：过滤数据，根据方法返回的布尔值 true 来收集数据
      // filter 方法查找满足条件的所有元素
      return this.article.thumbnails.filter((imageItem) => {
        // console.log(imageItem)
        return imageItem.type === '1'
      })
    }
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    getUrl () {
      return `${this.article.shareUrl}&contentType=${this.article.contentType}&isBjh=1`
    }
  }
}
</script>

<style lang="less" scoped>
.single-pic {
  margin: 7px 0;
  padding: 0 9px;
  // height: 60px;
  background-color: transparent;
  display: flex;
  flex-direction: row !important;
  justify-content: flex-start !important;
  .van-cell__title {
    flex: unset; // 取消flex ？
    width: 97px;
    height: 60px;
    margin-bottom: 10px;
  }
  .single-pic-default {
    margin-left: 12px;
    flex: unset;
    height: 65px;
    // background-color: pink;
    position: relative;
    .single-pic-article-title {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      span {
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 20px;
        max-height: 50px;
        text-align: left;
      }
    }
    // 单图时间
    .single-pic-label-wrap {
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
  }
}
// 单张图的大小
.right-cover {
  width: 97px;
  height: 60px;
  position: relative;
  .bjh-play-icon {
    position: absolute;
    width: 20px;
    height: 20px;
    left: 38.5px;
    top: 20px;
  }
}

.article-title {
  font-size: 14px;
  color: #3a3a3a;
}

.three-pic-class {
  background-color: transparent;
  padding-left: 0px;
  padding-right: 0px;
  // 三张图
  .cover-wrap {
    padding: 7px 0; //上下间距
    display: flex;
    .cover-wrap-item {
      flex: 1;
      height: 60px;
      &:not(:last-child) {
        padding-right: 15px; //除了最后一个图的右间距
      }
      .cover-image {
        width: 100%;
        height: 60px;
      }
    }
  }
}

// 时间
.label-wrap {
  font-size: 10px;
  color: #8c8b8b;
}
.label-wrap span {
  display: flex;
  justify-content: flex-end;
}
</style>
